if (!window.CustomerReviewsDock) {
window.CustomerReviewsDock = class CustomerReviewsDock {
  constructor(root) {
    this.root = root;
    this.button = root.querySelector('[data-reviews-dock-open]');
    this.modal = root.querySelector('[data-reviews-dock-modal]');
    this.panel = root.querySelector('[data-reviews-dock-panel]');
    this.desktopQuery = window.matchMedia('(min-width: 1024px)');
    this.isOpen = false;
    this.previouslyFocused = null;
    this.closeTimer = null;

    if (!this.button || !this.modal || !this.panel) return;

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onBreakpoint = this.onBreakpoint.bind(this);

    this.button.addEventListener('click', this.onButtonClick);
    this.modal.addEventListener('click', this.onOverlayClick);
    root.querySelectorAll('[data-reviews-dock-close]').forEach((control) => {
      control.addEventListener('click', () => this.close());
    });
    document.addEventListener('keydown', this.onKeydown);

    if (typeof this.desktopQuery.addEventListener === 'function') {
      this.desktopQuery.addEventListener('change', this.onBreakpoint);
    } else if (typeof this.desktopQuery.addListener === 'function') {
      this.desktopQuery.addListener(this.onBreakpoint);
    }
  }

  isDesktop() {
    return this.desktopQuery.matches;
  }

  onBreakpoint() {
    if (!this.isDesktop() && this.isOpen) this.close(true);
  }

  onButtonClick() {
    if (!this.isDesktop()) return;
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  onOverlayClick(event) {
    if (event.target === this.modal || event.target.hasAttribute('data-reviews-dock-overlay')) {
      this.close();
    }
  }

  onKeydown(event) {
    if (!this.isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = this.getFocusable();
    if (!focusable.length) {
      event.preventDefault();
      this.panel.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && (active === first || !this.panel.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  getFocusable() {
    return Array.from(
      this.panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter((element) => element.offsetParent !== null);
  }

  open() {
    if (!this.isDesktop() || this.isOpen) return;

    window.clearTimeout(this.closeTimer);
    this.previouslyFocused = document.activeElement;
    this.isOpen = true;
    this.modal.hidden = false;
    this.modal.setAttribute('aria-hidden', 'false');
    this.button.setAttribute('aria-expanded', 'true');
    document.body.classList.add('customer-reviews-dock-open');

    window.requestAnimationFrame(() => {
      this.modal.classList.add('is-open');
      const closeButton = this.panel.querySelector('[data-reviews-dock-close]');
      if (closeButton) {
        closeButton.focus();
      } else {
        this.panel.focus();
      }
    });
  }

  close(immediate) {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.modal.classList.remove('is-open');
    this.button.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('customer-reviews-dock-open');

    const finish = () => {
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
        this.previouslyFocused.focus();
      }
    };

    if (immediate) {
      finish();
      return;
    }

    this.closeTimer = window.setTimeout(finish, 260);
  }
};
}

function initCustomerReviewsDock(scope) {
  const root = scope || document;
  root.querySelectorAll('[data-customer-reviews-dock]').forEach((element) => {
    if (element.dataset.reviewsDockReady === 'true') return;
    element.dataset.reviewsDockReady = 'true';
    new window.CustomerReviewsDock(element);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCustomerReviewsDock());
} else {
  initCustomerReviewsDock();
}

document.addEventListener('shopify:section:load', (event) => {
  initCustomerReviewsDock(event.target);
});
